import { HorizontalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const PopoverTrigger = ({ displayIcon, displayText, selectedLabel, testId = TEST_ID }: Props) => (
    <HorizontalContainer className={styles.wrapper} testId={testId}>
        <div className={styles.bodyText}>{displayText}</div>

        {displayIcon !== undefined && (
            <>
                <div className={styles.bodyLabel}>{selectedLabel}</div>

                <div className={styles.bodyIcon}>{displayIcon}</div>
            </>
        )}
    </HorizontalContainer>
);

export default PopoverTrigger;
